import { keyBy, mapValues, omit } from 'lodash';
import { CLEAR_USER_COMMENTS } from '../../actions/clear-user-comments';
import { FETCH_USER_COMMENTS_SUCCESS } from '../../actions/fetch-comments-by-user';
import { DELETE_COMMENT_SUCCESS } from '../../actions/delete-comment';
import {
  INCREMENT_COMMENT_LIKE_COUNT_REQUEST,
  INCREMENT_COMMENT_LIKE_COUNT_SUCCESS,
  INCREMENT_COMMENT_LIKE_COUNT_FAILURE,
} from '../../actions/increment-comment-like-count';
import {
  INCREMENT_POST_LIKE_COUNT_REQUEST,
  INCREMENT_POST_LIKE_COUNT_SUCCESS,
  INCREMENT_POST_LIKE_COUNT_FAILURE,
} from '../../actions/increment-post-like-count';

const likeRequest = (state, action) => {
  if (state._id === action.payload._id) {
    return {
      ...state,
      isLiked: !state.isLiked,
      likeCount: state.likeCount + (state.isLiked ? -1 : 1),
      isLikeInProgress: true,
    };
  }
  return state;
};

const likeSuccess = (state, action) => {
  if (state._id === action.payload._id) {
    return omit({ ...state, ...action.payload }, 'isLikeInProgress');
  }
  return state;
};

const likeFailure = (state, action) => {
  if (state._id === action.payload._id) {
    return omit(
      {
        ...state,
        isLiked: !state.isLiked,
        likeCount: state.likeCount + (state.isLiked ? -1 : 1),
      },
      'isLikeInProgress',
    );
  }
  return state;
};

const post = (state, action) => {
  switch (action.type) {
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
      return likeRequest(state, action);
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
      return likeSuccess(state, action);
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      return likeFailure(state, action);
    default:
      return state;
  }
};

const comment = (state, action) => {
  switch (action.type) {
    case INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
      return likeRequest(state, action);
    case INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      return likeSuccess(state, action);
    case INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      return likeFailure(state, action);
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      return { ...state, post: post(state.post, action) };
    default:
      return state;
  }
};

export default (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_USER_COMMENTS:
      return {};
    case FETCH_USER_COMMENTS_SUCCESS:
      return { ...state, ...keyBy(action.payload, '_id') };
    case INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
    case INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
    case INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      return mapValues(state, (entity) => comment(entity, action));
    case DELETE_COMMENT_SUCCESS:
      return { ...omit(state, action.payload._id) };
    default:
      return state;
  }
};
